/**
 * @flow
 */
import React, {Component} from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { translate  } from 'react-i18next';
import { observer } from 'mobx-react';
import Settings from '../../Store/Settings';
import {Link} from 'react-router';

@observer
export class NavBrand extends Component {
  
  getLogoUrl(settings: any) {
    if(settings.has('logo')) {
      const logo = settings.get('logo');

      if (logo) return logo.url;
    }

    return null;
  }
  
  render () {
    const { t } = this.props;
    const { settings } = Settings;
    const logoUrl = this.getLogoUrl(settings);
    const websiteUrl = settings.get('website_url');
    const clientName = settings.get('client') ? settings.get('client').name : 'MyAirSeat';
    
    if (websiteUrl) {
        return (
          <a href={websiteUrl} className="navbar-brand" target="_blank">
            {
              logoUrl ?
                <img src={logoUrl} alt={clientName} /> :
                clientName
            }
          </a>
        )
    }

    return (
      <Link to="/" className="navbar-brand">
        {
          logoUrl ?
            <img src={logoUrl} alt={clientName} /> :
            clientName
        }
      </Link>
    )
  }
}

export default translate ()(NavBrand);



// WEBPACK FOOTER //
// ./src/App/Layout/Header/NavBrand.js